import { Contact } from '@vendasta/sales-v2';

export interface AccountsCustomFieldsData {
  accountGroupId: string;
  accountName: string;
  lastUpdateDate: Date;
  address: any;
  primaryContact: Contact;
  jsonSchema: any;
  jsonData: any;
}

export enum AccountsCustomFieldsTableColumns {
  ACCOUNT_NAME = 'accountName',
  CITY = 'city',
  STATE = 'state',
  LAST_UPDATE_DATE = 'lastUpdateDate',
  PRIMARY_CONTACT = 'primaryContact',
}
